import React, { useContext, useState, useRef, useEffect } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import TabName from "./TabName";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const TabPannel = ({ handleOpenTradeModal, handleOpenModifyPositionModal, handleChartFromTradeTabClick }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { darkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const tabContainerRef = useRef(null);
  const [showUpArrow, setShowUpArrow] = useState(false);
  const [showDownArrow, setShowDownArrow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const translatedTabs = TabName.map((tab) => ({ ...tab, name: t(tab.name), }));

  const checkScroll = () => {
    if (tabContainerRef.current) {
      setShowUpArrow(tabContainerRef.current.scrollTop > 0);
      setShowDownArrow(
        tabContainerRef.current.scrollTop < tabContainerRef.current.scrollHeight - tabContainerRef.current.clientHeight
      );
    }
  };

  useEffect(() => {
    checkScroll();
    tabContainerRef.current?.addEventListener("scroll", checkScroll);
    return () => tabContainerRef.current?.removeEventListener("scroll", checkScroll);
  }, []);

  const handleScroll = (direction) => {
    if (tabContainerRef.current) {
      tabContainerRef.current.scrollBy({ top: direction === "up" ? -50 : 50, behavior: "smooth" });
    }
  };

  return (
    <Box display="flex" sx={{ height: "100%", width: "100%" }}>
      <Box sx={{ height: "100%", width: "60px", border: `4px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}`, borderTop: "none",  backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", display: "flex", flexDirection: "column", alignItems: "center", padding: 1, flexShrink: 0, position: "relative", }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}>
        {isHovered && showUpArrow && (
          <IconButton onClick={() => handleScroll("up")} sx={{ p: 0, width: '100%', position: "absolute", top: 1, zIndex: 1, color: "var(--white)", backgroundColor: "rgba(0, 0, 0, 0.5)", "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" }, borderRadius: 0 }}><KeyboardArrowUpIcon /></IconButton>
        )}

        <Box ref={tabContainerRef} sx={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "center", overflowY: "auto", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" }, }}>
          {translatedTabs.map((tab, index) => (
            <Tooltip key={index} title={tab.name} placement="right">
              <IconButton onClick={() => setSelectedTab(index)} sx={{ fontSize: 22, color: selectedTab === index ? (darkMode ? "#70a9ff" : "#3183ff") : darkMode ? "#c5c5c5" : "#1c1c1c", "&:hover": { backgroundColor: darkMode ? "var(--background-color)" : "var(--borderLight)" }, }}>
                {tab.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>

        {isHovered && showDownArrow && (
          <IconButton onClick={() => handleScroll("down")} sx={{ p: 0, width: '100%', position: "absolute", bottom: 1, zIndex: 1, color: "var(--white)", backgroundColor: "rgba(0, 0, 0, 0.5)", "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" }, borderRadius: 0 }}><KeyboardArrowDownIcon /></IconButton>
        )}
      </Box>
      <Box sx={{ height: "100%", flexGrow: 1, border: `4px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}`, borderTop: "none", borderLeft: "none", borderRight: 0, overflowY: "auto",  "&::-webkit-scrollbar": {display: "none"}, scrollbarWidth: "none", msOverflowStyle: "none",}}>
        {translatedTabs[selectedTab]?.name === t("trade")
          ? translatedTabs[selectedTab]?.component(handleOpenTradeModal, handleOpenModifyPositionModal, handleChartFromTradeTabClick)
          : translatedTabs[selectedTab]?.name === t("accounts") ? translatedTabs[selectedTab]?.component(setSelectedTab) : translatedTabs[selectedTab]?.component}
      </Box>
    </Box>
  );
};

export default TabPannel;
